import { EuiBadge, EuiBadgeProps } from "@inscopix/ideas-eui";
import { memo } from "react";

export const EuiBadgeMemo = memo(function EuiBadgeMemo(props: EuiBadgeProps) {
  return <EuiBadge {...props} />;
});
